<div class="row" id="divArticleDataList">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="col-sm-12" id="divMainFilter">
          <div class="row">
            <div class="col-sm-2">
              <label>From</label>
              <input type="date" name="DOB" class="form-control float-right" id="Txt_FromDate" autocomplete="off">
            </div>
            <div class="col-sm-2">
              <label>To</label>
              <input type="date" name="DOB" class="form-control float-right" id="Txt_ToDate" autocomplete="off">
            </div>
            <div class="col-sm-2">
              <button type="button" id="btnPopupDT" class="btn btn-block btn-primary float-sm-right" (click)="showInfoPopUp()" style="display:none">POP-UP</button>
              <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Get" id="btnLoadList" (click)="LoadDataList()">Search</button>
              <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="ResetFilter()" style="margin-left:10px">Reset</button>
            </div>
          </div>
        </div>

        <table #dataTable class="display" style="width:100%"></table>

        <!-- The Modal -->
        <div class="modal" id="myModal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog modal-xl custome-modal">
            <div class="modal-content" id="divStatusCT">

              <!-- Modal Header -->
              <div class="modal-header">
                <h4 class="modal-title">{{ title }}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
              </div>

              <!-- Modal body -->
              <div class="modal-body">
                <form #form="ngForm" id="frmarticletracking">
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col">
                        <div id="divStartXML"></div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!-- Modal footer -->
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
              </div>
            </div>
            <div id="LoadingImagePopup">
              <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
            </div>
          </div>

        </div>


      </div>
    </div>
  </div>
</div>
